import { useLingui } from '@lingui/react/macro';
import WinBase from '../components/base/win-base';
import { UDFormLabeledInput } from 'ud-form/components';

const FootballWin = () => {
  const { t } = useLingui();

  return (
    <WinBase sportType="football">
      <div className="mt-4">
        <UDFormLabeledInput
          name="settings.winPenaltySeries"
          placeholder={t`0 очков`}
          label={t`В серии послематчевых пенальти`}
          containerClassName="flex items-center"
          tooltip={t`Количество очков за победу по пенальти (если основное и дополнительное время не выявили победителя).`}
          tooltipProps={{ position: 'input-right' }}
        />
      </div>
    </WinBase>
  );
};

export default FootballWin;
